import {
    InputSearchBpl,
    LocationStatus,
    OpenSearchType,
    WildCardTitleSearchConnection,
} from 'src/types/schema/graphql'

import { apiRequest, RequestInput } from 'src/api/apiRequest'
import searchBPLLocations from 'src/features/locations/utils/graph/searchBPLLocations'
import { mapStore } from 'src/features/Map/state/mapStore'

export const searchLocationsByWildcard = async (wildcardText: string) => {
    const { setWildcardSelectionLocationOptions, setWildcardInputLoading } = mapStore.getState()

    const input: RequestInput<InputSearchBpl> = {
        query: searchBPLLocations,
        args: {
            input: {
                limit: 5,
                typeFilters: [OpenSearchType.Location],
                search: {
                    wildcardText: wildcardText || '',
                    searchFieldsLocations: {
                        status: LocationStatus.OpenForBusiness,
                    },
                },
                nextToken: null,
            },
        },
        file: 'searchLocationsByWildcard.ts',
        endpoint: 'searchBpl',
        publicQuery: true,
        noAlerts: true,
    }
    const { data } = await apiRequest<WildCardTitleSearchConnection, InputSearchBpl>(input)

    if (data) setWildcardSelectionLocationOptions(data.items)
    setWildcardInputLoading(false)
    return data
}
